import React, { Component } from 'react';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { withOktaAuth } from '@okta/okta-react';
import { connect } from 'react-redux';


const AdminHeader = ({ updatedDateTime, location }) => {

    const menuItem = [
        {
            key: 'isi-home', display: 'Home', route: '/',
        },
        {
            key: 'admin-user-exception', display: 'Zoom License Exceptions', route: '/admin',
        },
        {
            key: 'admin-application', display: 'Application', route: '/admin/application',
        }, {
            key: 'admin-zoom-logging', display: 'Zoom Log', route: '/admin/zoom-log',
        },
    ];

    return (<div className="main-header" style={{ fontFamily: 'interBoldUI' }}>
        {/* <!-- Logo Header --> */}
        <div className="logo-header" data-background-color="white">
            <a href="/" className="logo" id="logoHeader">
                <img src="../../../assets/img/intuitive_logo_black.png" alt="navbar brand"
                     className="navbar-brand"></img>
            </a>
        </div>
        <nav className="navbar navbar-header navbar-expand-lg" data-background-color="white">
            <div className="container-fluid">
                <h2 className="text-black pb-2 fw-bold" id="appName">Admin</h2>
                <ul className="navbar-nav topbar-nav ml-md-auto align-items-center">
                    <li className="nav-item dropdown hidden-caret submenu show">
                        <a className="dropdown-toggle profile-pic" id="dropdownMenuButton" data-toggle="dropdown"
                           aria-haspopup="true" aria-expanded="false">
                            <div className="avatar-sm">
                                <img src="/assets/img/profile_placeholder.png" alt="..."
                                     className="avatar-img rounded-circle"></img>
                            </div>
                        </a>
                        <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                            {
                                menuItem.filter(f => f.route !== location.pathname).map(item => (
                                    <a key={item.key} className="dropdown-item" href={item.route}>{item.display}</a>))
                            }
                        </div>
                    </li>
                </ul>
            </div>
        </nav>
    </div>);
};

const mapStateToProps = (state) => ({
    updatedDateTime: state.userException.updatedDateTime,
});

export default compose(withRouter, withOktaAuth, connect(mapStateToProps, {}))(AdminHeader);